import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Zap } from 'lucide-react';
export function Pricing() {
  const features = ['6 Tomos completos', '6 Bonos exclusivos', 'Actualizaciones futuras', 'Acceso inmediato'];
  return <section id="pricing" className="py-24 lg:py-32 bg-accent-50 relative overflow-hidden" data-id="element-151">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#FAF8F5] rounded-full blur-3xl opacity-80 pointer-events-none" data-id="element-152"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-154">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-brand-900 text-white font-medium text-xs uppercase tracking-widest mb-8 shadow-sm" data-id="element-155">
            <Zap className="w-4 h-4 text-accent-400" data-id="element-156" />
            Oferta · Últimos cupos
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-ink-900 tracking-tight leading-tight" data-id="element-157">
            Reservá tu acceso al{' '}
            <span className="text-brand-600 italic" data-id="element-158">Mega Pack</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] p-8 md:p-14 shadow-md border border-accent-100/50 relative max-w-xl mx-auto" data-id="element-159">
          {/* Top tag */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-700 text-white font-medium px-6 py-2 rounded-full text-xs uppercase tracking-widest shadow-sm whitespace-nowrap" data-id="element-160">
            Acceso completo
          </div>

          <div className="text-center mb-10 pt-4" data-id="element-161">
            <div className="text-ink-900 font-serif font-medium text-2xl mb-2" data-id="element-162">
              Mega Pack Yoga Listo 2026
            </div>
            <p className="text-ink-500 text-sm mb-8 font-light" data-id="element-163">
              6 Tomos + 6 Bonos + Garantía de 7 días
            </p>

            <div className="mb-3 flex items-center justify-center gap-4" data-id="element-164">
              <span className="text-ink-400 line-through text-2xl font-light" data-id="element-165">
                $64.990
              </span>
              <span className="bg-accent-50 text-accent-700 font-medium text-xs px-3 py-1.5 rounded-full uppercase tracking-widest" data-id="element-166">
                -70%
              </span>
            </div>
            <div className="text-6xl md:text-7xl font-serif font-medium text-brand-900 mb-4 tracking-tight" data-id="element-167">
              $19.990
            </div>
            <p className="text-sm text-ink-500 font-light" data-id="element-168">
              Pago único · Sin suscripción
            </p>
          </div>

          <div className="space-y-4 mb-10 bg-[#FAF8F5] rounded-[2rem] p-8" data-id="element-169">
            {features.map((feature, i) => <div key={i} className="flex items-center gap-4" data-id="element-170">
                <div className="w-6 h-6 rounded-full bg-brand-100 text-brand-700 flex items-center justify-center shrink-0" data-id="element-171">
                  <Check className="w-3.5 h-3.5" strokeWidth={2} data-id="element-172" />
                </div>
                <span className="text-ink-800 font-medium text-base" data-id="element-173">
                  {feature}
                </span>
              </div>)}
          </div>

          <a href="https://www.iterapro.shop/cart/43375972221017:1" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-brand-700 hover:bg-brand-800 text-white font-medium py-5 px-6 rounded-full transition-all transform hover:-translate-y-0.5 shadow-md hover:shadow-lg text-lg tracking-wide" data-id="element-174">
            QUIERO MI MEGA PACK
          </a>

          <p className="text-center text-xs text-ink-400 mt-6 inline-flex items-center justify-center gap-2 w-full font-light" data-id="element-175">
            <Lock className="w-3.5 h-3.5" data-id="element-176" />
            Pago 100% seguro · Mercado Pago · Tarjeta · Transferencia
          </p>
        </motion.div>
      </div>
    </section>;
}